import request from '@/utils/request'
import { handlerGetUrlParams } from '@/utils/dealUrlParams.js'

// 获取人才信息
export function getTalentsInfo(params) {
  const url = handlerGetUrlParams('/bus/talent/list', params)
  return request({
    url,
    method: 'GET'
  })
}

// 删除人才信息
export function deleteTalentsInfo(params) {
  return request({
    url: `/bus/talent/${params}`,
    method: 'DELETE'
  })
}

// 发布和下架人才信息
export function statusTalentsInfo(data) {
  return request({
    url: `/bus/talent/status`,
    method: 'PUT',
    data
  })
}

export function talentUpdate(data) {
  return request({
    url: `/bus/talent`,
    method: 'PUT',
    data
  })
}

export function increaseTalent(data) {
  return request({
    url: `/bus/talent`,
    method: 'POST',
    data
  })
}

export function queryTalentInfos(id) {
  return request({
    url: `/bus/talent/${id}`,
    method: 'GET'
  })
}
// export function talentStatus(data) {
//   return request({
//     url: `/bus/talent/status`,
//     method: 'PUT',
//     data
//   })
// }

// 新增技术团队信息
export function addTeamInfo(data) {
  return request({
    url: `/bus/team`,
    method: 'POST',
    data
  })
}
// 获取技术团队信息
export function getTeamInfo(params) {
  const url = handlerGetUrlParams('/bus/team/list', params)
  return request({
    url,
    method: 'GET'
  })
}

// 获取技术团队详情
export function queryTeamInfos(id) {
  return request({
    url: `/bus/team/${id}`,
    method: 'GET'
  })
}
// 修改技术团队
export function teamUpdate(data) {
  return request({
    url: `/bus/team`,
    method: 'PUT',
    data
  })
}
// 发布和下架技术团队信息
export function updateStatus(data) {
  return request({
    url: `/bus/team/updateStatus`,
    method: 'POST',
    data
  })
}
// 删除团队信息
export function deleteTeamInfo(params) {
  return request({
    url: `/bus/team/${params}`,
    method: 'DELETE'
  })
}
